export const MEDIA_LIBRARY_ASSET_TYPE_HTML_PACKAGE = 'html_package';
export const MEDIA_LIBRARY_ASSET_TYPE_OTHER = 'other';
export const MEDIA_LIBRARY_ASSET_TYPE_PDF = 'pdf';
export const MEDIA_LIBRARY_ASSET_TYPE_IMAGE = 'photo';
export const MEDIA_LIBRARY_ASSET_TYPE_PPT = 'ppt';
export const MEDIA_LIBRARY_ASSET_TYPE_VIDEO = 'video';
export const MEDIA_LIBRARY_ASSET_TYPE_YOUTUBE = 'youtube';

export const ALL_MEDIA_LIBRARY_ASSET_TYPES = Object.freeze([
  MEDIA_LIBRARY_ASSET_TYPE_HTML_PACKAGE,
  MEDIA_LIBRARY_ASSET_TYPE_IMAGE,
  MEDIA_LIBRARY_ASSET_TYPE_OTHER,
  MEDIA_LIBRARY_ASSET_TYPE_PDF,
  MEDIA_LIBRARY_ASSET_TYPE_PPT,
  MEDIA_LIBRARY_ASSET_TYPE_VIDEO,
  MEDIA_LIBRARY_ASSET_TYPE_YOUTUBE
]);